<div class="gw-flex gw-flex-col gw-bg-background-elevation-3">
  <!-- Header -->
  <div class="gw-flex gw-items-center gw-justify-between gw-p-4 sm:gw-p-6">
    <h2 class="gw-flex gw-items-center gw-gap-2 gw-text-lg gw-font-semibold">
      <i class="fas fa-shield-alt gw-text-primary-500"></i>
      <span class="gw-text-text-primary">{{
        'common.twoFactor.title' | translate
      }}</span>
    </h2>
  </div>

  <!-- Body -->
  <div class="gw-space-y-4 gw-p-4 sm:gw-p-6">
    <div class="gw-text-center">
      <div
        class="gw-inline-flex gw-items-center gw-justify-center gw-w-14 gw-h-14 gw-rounded-full gw-bg-primary-500/10 gw-mb-3"
      >
        <gatewee-icon
          icon="@tui.shield-check"
          size="56px"
          iconStyle="primary"
        ></gatewee-icon>
      </div>
      <h3 class="gw-text-base gw-font-medium gw-text-text-primary gw-mb-1">
        {{ 'common.twoFactor.instruction' | translate }}
      </h3>
      <p class="gw-text-sm gw-text-text-secondary">
        {{ 'common.twoFactor.hint' | translate }}
      </p>
    </div>

    <div class="gw-mx-auto gw-w-full gw-max-w-[360px]">
      <tui-textfield
        tuiTextfieldSize="m"
        class="gw-w-full"
        [class.gw-opacity-60]="submitting"
        [style.-webkit-text-security]="'disc'"
      >
        <input
          tuiInputPin
          maxlength="6"
          placeholder="••••••"
          autocomplete="one-time-code"
          inputmode="numeric"
          [formControl]="pinControl"
          [disabled]="pinInputDisabled"
        />
      </tui-textfield>

      <div
        *ngIf="submitting"
        class="gw-mt-small gw-flex gw-items-center gw-justify-center gw-gap-2 gw-text-sm gw-text-text-secondary"
        aria-live="polite"
      >
        <span
          class="gw-button-spinner gw-text-text-action"
          aria-hidden="true"
        ></span>
        <span>{{ 'common.twoFactor.verifying' | translate }}</span>
      </div>

      <p
        *ngIf="verificationError && !submitting"
        class="gw-m-0 gw-mt-small gw-text-center gw-text-sm gw-text-status-negative"
        role="alert"
      >
        {{ verificationError }}
      </p>
    </div>

    <div
      *ngIf="expired"
      class="gw-p-3 gw-rounded-xl gw-bg-warning-500/10 gw-border gw-border-warning-500/30 gw-text-warning-700 dark:gw-text-warning-400"
    >
      {{ 'common.twoFactor.expired' | translate }}
    </div>

    <p class="gw-text-center gw-text-sm gw-text-text-secondary">
      {{ 'common.twoFactor.resendTimer' | translate }}: {{ minutes }}:{{
        seconds | number : '2.0-0'
      }}
    </p>
  </div>

  <!-- Footer -->
  <div
    class="gw-flex gw-flex-col-reverse gw-gap-2 gw-p-4 sm:gw-flex-row sm:gw-items-center sm:gw-justify-between sm:gw-p-6"
  >
    <div class="gw-flex gw-items-center gw-justify-end">
      <gatewee-button
        class="gw-w-full sm:gw-w-auto"
        type="button"
        variant="outline"
        iconName="@tui.x"
        [title]="'common.actions.cancel' | translate"
        [disabled]="submitting"
        (clicked)="closeModal()"
      ></gatewee-button>
    </div>
    <div class="gw-flex gw-items-center gw-justify-end gw-gap-2">
      <gatewee-button
        *ngIf="expired"
        class="gw-w-full sm:gw-w-auto"
        type="button"
        variant="secondary"
        iconName="@tui.refresh-cw"
        [title]="'common.twoFactor.resend' | translate"
        [disabled]="submitting"
        (clicked)="resendCode()"
      ></gatewee-button>
      <gatewee-button
        *ngIf="!expired"
        class="gw-w-full sm:gw-w-auto"
        iconName="@tui.check"
        [title]="'common.actions.confirm' | translate"
        [disabled]="!isOtpValid"
        [loading]="submitting"
        (clicked)="submit()"
      ></gatewee-button>
    </div>
  </div>
</div>
